<template lang="pug">
div
  b-card
    .container-fluid
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 固定ページ編集
          p.text-muted.m-b-30.font-13 SWAN Proサイトの固定ページ編集画面
          form.form-horizontal
            .form-group
              label.col-md-12 ページ名
              .col-md-12
                el-input(type='text', v-model='formData.page_name', placeholder='securityといったURLに反映されます')
            .form-group
              label(for='言語').col-md-12 言語
              .col-md-12
                el-select(v-model='formData.locale', disabled='')
                  el-option(value='ja', label='日本語')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語')
                  el-option(value='kr', label='韓国語')
            .form-group(v-if='formData.entry_id')
              label(for='他の言語').col-md-12 他の言語 
              .col-md-12
                a(v-if="formData.locale!='ja'" :href='locale_url.ja' replace) 日本語&nbsp;&nbsp;
                a(v-if="formData.locale!='en'" :href='locale_url.en' replace) 英語&nbsp;&nbsp;
                a(v-if="formData.locale!='cn'" :href='locale_url.cn' replace) 中国語&nbsp;&nbsp;
                a(v-if="formData.locale!='kr'" :href='locale_url.kr' replace) 韓国語&nbsp;&nbsp;
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                el-input(type='text', v-model='formData.title')
            .form-group
              label.col-md-12 サブタイトル
              .col-md-12
                el-input(type='text', v-model='formData.subtitle')
              .form-group
                label.col-md-12 ヘッダ背景画像
                //- .col-md-12
                //-   input(type='file',　v-on:change='onFileAdd($event)')
              //- img(v-show='formdata.header_image' :src='formdata.header_image')
            .form-group(v-if='savedImageLength')
              //- label.col-md-12 登録済み画像
              .col-md-12
                el-table(:data='formData.headerImages')
                  el-table-column(label="image", width="300")
                    template(slot-scope="scope")
                      img(:src='scope.row.img_url', height='128')
                  el-table-column(property='img_url', label='image_url', width='500')
                  el-table-column(label='')
                    template(slot-scope='scope')
                      el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteConfirm(scope.$index)')
            .form-group(v-if='uploadedImagesLength')
              //- span.col-md-12 画像
              el-button(style='margin-left:18px', type='primary', icon='el-icon-plus', size='mini', @click='onBtnFileAdd', v-if='formData.uploadedImages.length === 0')
              .col-md-12
                el-table(:data='formData.uploadedImages')
                  el-table-column(label='image', width='300')
                    template(slot-scope='scope')
                      img(:src='scope.row.image', height='128')
                  el-table-column(property='name', label='name', width='500')
                  el-table-column(label='')
                    template(slot-scope='scope')
                      el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteSubConfirm(scope.$index)') 
              input#btnFileAdd(type='file', style='visibility: hidden', @change='onFileAdd($event)', accept='image/*')
            .form-group
              label.col-md-12 リードテキスト
              .col-md-12
                el-input(type='textarea', v-model='formData.lead_text', :autosize='{ minRows: 2}')
            .form-group
              label.col-md-12 HTMLソース
              .col-md-12
                el-input(type='textarea', :autosize="{ minRows: 2}", v-model='formData.html')
                
  .card
    .col-md-12
      publicSetting(apiname='static', :formdata='formData')

</template>

<script>
import axios from 'axios'
import moment from 'moment'
import PublicSetting from '@/views/components/swan/common/PublicSetting'

export default {
  name: 'StaticEdit',
  data () {
    return {
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      formData: {
        'page_name': '',
        'title': '',
        'subtitle': '',
        'header_image': '',
        'lead_text': '',
        'locale': '',
        'html': '',
        'entry_id': '',
        'status': '',
        'agree_list': [],
        'agree_user': '',
        'open_date': '',
        'close_date': '',
        'uploadedImages': [],
        'headerImages': [],
        'waiting': false
      },
      header_image_arr: []
    }
  },
  components: {
    PublicSetting
  },
  created () {
    if (this.$route.query.id && this.$route.query.locale) {
      this.locale_url.ja = '?id=' + this.$route.query.id + '&locale=ja'
      this.locale_url.en = '?id=' + this.$route.query.id + '&locale=en'
      this.locale_url.cn = '?id=' + this.$route.query.id + '&locale=cn'
      this.locale_url.kr = '?id=' + this.$route.query.id + '&locale=kr'
      this.header_image_arr = []
      this.savedImageLength = false
      this.uploadedImagesLength = false
      axios({
        method: 'GET',
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/static/edit?entry_id=' + this.$route.query.id + '&locale=' + this.$route.query.locale
      })
        .then((res) => {
          if (Object.keys(res.data).length) {
            let content = res.data
            console.dir(content)
            if (content.header_image !== '') {
              this.savedImageLength = true
              this.formData.headerImages.push({img_url: content.header_image})
              // console.log(content.headerImages)
            } else {
              this.uploadedImagesLength = true
            }
            this.formData.entry_id = this.$route.query.id
            this.formData.page_name = content.page_name
            this.formData.title = content.title
            this.formData.subtitle = content.subtitle
            this.formData.header_image = content.header_image
            this.formData.lead_text = content.lead_text
            this.formData.html = content.html
            this.formData.locale = this.$route.query.locale
            this.formData.staff_list = content.staff_list
            this.formData.agree_list = content.agree_list
            this.formData.agree_user = content.agree_user
            this.formData.status = content.status
            this.formData.waiting = content.waiting
            if (content.open_at) {
              this.formData.open_date = moment(content.open_at).format('YYYY-MM-DD')
              this.formData.open_time = moment(content.open_at).format('HH:mm')
            }
            if (content.close_at) {
              this.formData.close_date = moment(content.close_at).format('YYYY-MM-DD')
              this.formData.close_time = moment(content.close_at).format('HH:mm')
            }
            this.formData.created_at = moment(content.created_at).format('YYYY-MM-DD HH:mm:ss')
            this.formData.updated_at = moment(content.updated_at).format('YYYY-MM-DD HH:mm:ss')
          } else {
            this.savedImageLength = false
            this.uploadedImagesLength = true
            this.formData.entry_id = this.$route.query.id
            this.formData.locale = this.$route.query.locale
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      this.savedImageLength = false
      this.uploadedImagesLength = true
      this.formData.locale = 'ja'
    }
  },
  methods: {
    onBtnFileAdd (e) {
      document.getElementById('btnFileAdd').click()
    },
    onFileAdd (e) {
      let files = e.target.files || e.dataTransfer.files
      // console.log(files)
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.formData.uploadedImages.push({name: files[0].name, image: r.target.result})
        }
        console.log(this.formData.uploadedImages)
        this.subImageCount++
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    },
    deleteConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formData.headerImages.splice(index, 1)
        this.savedImageLength = false
        this.uploadedImagesLength = true
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteSubConfirm (index) {
      console.log(index)
      this.$confirm(this.formData.uploadedImages[index].name + 'を削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formData.uploadedImages.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/static/edit.vue